import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CheckCircle, MessageCircle, Home } from 'lucide-react';
import { api } from '../api';
import { useApp } from '../contexts/AppContext';

export default function OrderSuccessPage() {
  const { id } = useParams();
  const { t, lang, formatPrice, whatsappNumber } = useApp();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.getOrder(id).then(r => setOrder(r.data)).catch(() => {});
  }, [id]);

  const handleWhatsApp = () => {
    const num = whatsappNumber?.replace(/\D/g, '');
    if (!num) return;
    const text = lang === 'ar'
      ? `مرحباً، تم تقديم طلبي برقم: ${id.substring(0, 8)}. أرجو التأكيد.`
      : `Hello, I placed order #${id.substring(0, 8)}. Please confirm.`;
    window.open(`https://wa.me/${num}?text=${encodeURIComponent(text)}`, '_blank');
  };

  return (
    <div className="page-pb page-center" style={{ textAlign: 'center', padding: '60px 24px 0' }}>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
        <CheckCircle size={80} color="#22c55e" />
      </div>
      <div style={{ fontSize: 24, fontWeight: 800, color: '#111', marginBottom: 8 }}>{t.orderSuccess}</div>
      <div style={{ fontSize: 15, color: '#6b7280', marginBottom: 24, maxWidth: 300, margin: '0 auto 24px' }}>{t.orderSuccessDesc}</div>

      {order && (
        <div style={{ background: '#fff', borderRadius: 16, padding: 16, margin: '0 0 24px', boxShadow: '0 2px 12px rgba(0,0,0,0.07)', textAlign: lang === 'ar' ? 'right' : 'left' }}>
          <div style={{ fontSize: 12, color: '#9ca3af', marginBottom: 4 }}>{t.orderNumber}</div>
          <div style={{ fontWeight: 700, color: '#111', marginBottom: 12, fontSize: 14 }}>{id.substring(0, 8).toUpperCase()}</div>

          {order.sheep?.map(s => (
            <div key={s.id} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14, padding: '4px 0', borderBottom: '1px solid #f5f5f5' }}>
              <span>{lang === 'ar' ? s.breed_ar : s.breed_en || s.given_name}</span>
              <span style={{ fontWeight: 600, color: '#166534' }}>{formatPrice(s.online_price)}</span>
            </div>
          ))}

          <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 800, fontSize: 16, marginTop: 10 }}>
            <span>{t.total}</span>
            <span style={{ color: '#166534' }}>{formatPrice(order.total_price_kwd)}</span>
          </div>

          <div style={{ marginTop: 12, background: '#f0fdf4', borderRadius: 10, padding: '8px 12px' }}>
            <span style={{ fontSize: 12, color: '#166534', fontWeight: 600 }}>
              {lang === 'ar' ? `الحالة: قيد المراجعة` : `Status: Pending Review`}
            </span>
          </div>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {whatsappNumber && (
          <button onClick={handleWhatsApp} style={{
            background: '#25D366', color: '#fff', border: 'none',
            borderRadius: 16, padding: '14px 0', cursor: 'pointer',
            fontSize: 15, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8
          }}>
            <MessageCircle size={18} />{lang === 'ar' ? 'تواصل للتأكيد' : 'Contact to Confirm'}
          </button>
        )}
        <button onClick={() => navigate('/orders')} style={{
          background: '#f3f4f6', color: '#374151', border: 'none',
          borderRadius: 16, padding: '12px 0', cursor: 'pointer', fontSize: 15, fontWeight: 600
        }}>{t.trackOrder}</button>
        <button onClick={() => navigate('/')} style={{
          background: 'none', color: '#8B1A1A', border: 'none',
          cursor: 'pointer', fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6
        }}>
          <Home size={16} />{t.continueShopping}
        </button>
      </div>
    </div>
  );
}
